import './bootstrap';
import 'flowbite';
import 'print-js';
import '@fontsource-variable/open-sans';
import '@fontsource-variable/open-sans/wght-italic.css';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';

//Adiciona no objeto global do navegador os helpers criados para o projeto
//Desta forma, conseguimos utilizar dentro de scripts que estão nas views Blade, chamando "Helpers.nomeDoHelper()"
import * as Helpers from './helpers';
window.Helpers = Helpers;

// Carrega todas as imagens no processo de build (app principal e módulos).
import.meta.glob([
    '../images/**',
    '/Modules/*/resources/images/**/*.{jpg,jpeg,png,gif,svg,webp,avif,ico,bmp,tiff}',
]);

window.driver = driver;
window.printJS = printJS;

window.Spinner = (function () {
    const spinnerElement = document.createElement('div');
    spinnerElement.className = 'flex items-center justify-center top-0 bottom-0 start-0 end-0 bg-black/30 backdrop-blur-sm z-[99999]';
    spinnerElement.innerHTML = `
        <div class="flex items-center text-xl text-white">
            <svg aria-hidden="true" class="inline w-10 h-10 text-gray-200 animate-spin dark:text-gray-600 fill-sky-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
            </svg>
            <span class="message ms-3"></span>
        </div>
    `;

    const messageNode = spinnerElement.querySelector('.message');
    const defaultMessage = 'Carregando...';

    let elementWithChangedPosition = null;

    return {
        show: function (target = null, message = null) {
            // Se por acaso o show for chamado duas vezes seguidas, limpa o anterior por segurança
            this.hide();

            messageNode.textContent = message || defaultMessage;

            let parentNode = document.body;

            if (target) {
                const foundTarget = typeof target === 'string' ? document.querySelector(target) : target;

                if (foundTarget) {
                    parentNode = foundTarget;

                    if (parentNode !== document.body
                        && getComputedStyle(parentNode).position === 'static'
                            && !parentNode.classList.contains('relative')) {
                        parentNode.classList.add('relative');
                        elementWithChangedPosition = parentNode;
                    }

                } else {
                    console.warn(`[Spinner] Alvo "${target}" não encontrado. O spinner será exibido no body.`);
                }
            }

            // Alterna dinamicamente a posição dependendo do alvo
            if (parentNode === document.body) {
                spinnerElement.classList.add('fixed');
                spinnerElement.classList.remove('absolute');

            } else {
                spinnerElement.classList.add('absolute');
                spinnerElement.classList.remove('fixed');
            }

            parentNode.appendChild(spinnerElement);
        },

        hide: function () {
            spinnerElement.remove();

            // Se alteramos a position de algum elemento, revertemos a alteração
            if (elementWithChangedPosition) {
                elementWithChangedPosition.classList.remove('relative');
                elementWithChangedPosition = null;
            }
        }
    };
})();

/**
 * Garante que o Spinner seja escondido, caso a página seja restaurada do cache
 * de navegação (quando o usuário clica em "Voltar" ou "Avançar" no navegador).
 */
window.addEventListener('pageshow', function (event) {
    // event.persisted é true se a página veio do Back/Forward Cache
    if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
        Spinner.hide();
    }
});
